import React from "react";
import { Link } from "react-router-dom";
import { AuthFrame } from "./auth-brand";
import "./login.css";

class RegisterView extends React.Component {
  state = {
    name: "",
    surname: "",
    email: "",
    password: "",
    confirmPassword: "",
    error: null,
    submitting: false,
  };

  handleChange = (field, value) => {
    this.setState({ [field]: value, error: null });
  };

  validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  submit = () => {
    const { name, surname, email, password, confirmPassword } = this.state;

    if (!name.trim() || !surname.trim()) {
      this.setState({ error: "Name and surname are required" });
      return;
    }
    if (!this.validateEmail(email)) {
      this.setState({ error: "Please enter a valid email address" });
      return;
    }
    if (!password || password.length < 6) {
      this.setState({ error: "Password must be at least 6 characters" });
      return;
    }
    if (password !== confirmPassword) {
      this.setState({ error: "Passwords do not match" });
      return;
    }

    this.setState({ submitting: true, error: null });
    this.props.dispatchRegister({
      name: name.trim(),
      surname: surname.trim(),
      username: email.trim().toLowerCase(),
      password,
      confirmPassword,
    });
  };

  componentDidUpdate(prevProps) {
    if (this.props.registerError && this.props.registerError !== prevProps.registerError) {
      this.setState({ submitting: false, error: this.props.registerError });
    }
  }

  render() {
    if (this.props.user && this.props.user._id) {
      return null; // Will redirect via Routes
    }

    const { name, surname, email, password, confirmPassword, error, submitting } = this.state;
    const isValid =
      name.trim() &&
      surname.trim() &&
      this.validateEmail(email) &&
      password.length >= 6 &&
      password === confirmPassword;

    return (
      <AuthFrame tagline="Start free — set MoneyApp up the way your trade actually works.">
        <div className="auth-card">
          <div className="auth-card-head">
            <h1>Create your account</h1>
            <p className="auth-sub">Up and running today — no setup fee, no card required.</p>
          </div>

          {error && <div className="auth-alert"><i className="fas fa-exclamation-circle" /> {error}</div>}

          <form onSubmit={(e) => { e.preventDefault(); this.submit(); }}>
            <div className="auth-row">
              <label className="auth-field">
                <i className="fas fa-user" />
                <input type="text" placeholder="First name" data-testid="register-name" autoFocus
                  value={name} onChange={(e) => this.handleChange("name", e.target.value)} />
              </label>
              <label className="auth-field">
                <i className="fas fa-user" />
                <input type="text" placeholder="Last name" data-testid="register-surname"
                  value={surname} onChange={(e) => this.handleChange("surname", e.target.value)} />
              </label>
            </div>

            <label className="auth-field">
              <i className="fas fa-envelope" />
              <input type="email" placeholder="Email" data-testid="register-email" autoComplete="email"
                value={email} onChange={(e) => this.handleChange("email", e.target.value)} />
            </label>

            <label className="auth-field">
              <i className="fas fa-lock" />
              <input type="password" placeholder="Password" data-testid="register-password" autoComplete="new-password"
                value={password} onChange={(e) => this.handleChange("password", e.target.value)} />
            </label>

            <label className="auth-field">
              <i className="fas fa-lock" />
              <input type="password" placeholder="Confirm password" data-testid="register-confirm" autoComplete="new-password"
                value={confirmPassword} onChange={(e) => this.handleChange("confirmPassword", e.target.value)} />
            </label>

            {/* Live hints so it's obvious why Create account is disabled */}
            {(password || confirmPassword) && (
              <ul className="auth-reqs" data-testid="register-reqs">
                <li className={password.length >= 6 ? "met" : "unmet"}>
                  <i className={`fas ${password.length >= 6 ? "fa-check-circle" : "fa-circle"}`} />
                  At least 6 characters
                </li>
                <li className={password && password === confirmPassword ? "met" : "unmet"}>
                  <i className={`fas ${password && password === confirmPassword ? "fa-check-circle" : "fa-circle"}`} />
                  Passwords match
                </li>
              </ul>
            )}

            <button type="submit" className="auth-btn" data-testid="register-submit" disabled={!isValid || submitting}>
              {submitting ? "Creating account…" : "Create account"}
            </button>
          </form>

          <p className="auth-alt">
            Already have an account? <Link to="/login">Sign in</Link>
          </p>
        </div>
      </AuthFrame>
    );
  }
}

export default RegisterView;
